// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ReportMessageModal Styles
 * Modal for reporting messages with severity and reason
 */

/* Overlay */
.report-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
}

/* Modal Container */
.report-modal {
  background: #FFFFFF;
  border-radius: 20px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
  width: 450px;
  max-width: 90vw;
  display: flex;
  flex-direction: column;
  font-family: 'Open Sans', sans-serif;
  overflow: hidden;
}

/* Header */
.report-modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 24px 16px 24px;
  position: relative;
}

.report-modal-title {
  margin: 0;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0;
  color: #2E2E2E;
  text-align: center;
}

.report-modal-close {
  position: absolute;
  right: 15px;
  top: 15px;
  background: #4A4A4A;
  border: none;
  font-size: 20px;
  color: #FFFFFF;
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  line-height: 1;
}

.report-modal-close:hover {
  background: #333333;
}

/* Body */
.report-modal-body {
  padding: 0 24px 16px 24px;
}

/* Form Fields */
.report-modal-field {
  margin-bottom: 16px;
}

.report-modal-label {
  display: block;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #4A4A4A;
  margin-bottom: 8px;
}

/* Severity Dropdown */
.report-modal-select {
  width: 100%;
  height: 44px;
  padding: 10px 16px;
  border: 2px solid #CDCCCD;
  border-radius: 8px;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  color: #000000;
  background: #FFFFFF;
  cursor: pointer;
  appearance: auto;
}

.report-modal-select:focus {
  outline: none;
  border-color: #DE4858;
}

/* Reason Textarea */
.report-modal-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #CDCCCD;
  border-radius: 8px;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  color: #000000;
  background: #FFFFFF;
  resize: vertical;
  min-height: 100px;
  box-sizing: border-box;
}

.report-modal-textarea:focus {
  outline: none;
  border-color: #DE4858;
}

.report-modal-textarea::placeholder {
  color: #9B9B9B;
}

/* Encryption Warning */
.report-modal-encryption-warning {
  color: #E67E22;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  margin: 8px 0 0 0;
  padding: 10px 12px;
  background-color: rgba(230, 126, 34, 0.1);
  border-radius: 8px;
  border-left: 3px solid #E67E22;
}

/* Action Buttons */
.report-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding: 20px 24px 24px 24px;
  border-top: 1px solid #E5E5E5;
}

.report-modal-btn {
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0;
  height: 45px;
  padding: 10px 24px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
  min-width: 100px;
}

.report-modal-btn-cancel {
  background: #D8D8D8;
  color: #6A6A6A;
  border: none;
}

.report-modal-btn-cancel:hover:not(:disabled) {
  background-color: #CDCCCD;
}

.report-modal-btn-cancel:disabled {
  background: #E8E8E8;
  color: #AAAAAA;
  cursor: not-allowed;
}

.report-modal-btn-submit {
  background: #DE4858;
  color: #FFFFFF;
  border: none;
}

.report-modal-btn-submit:hover:not(:disabled) {
  background: #C83E4E;
}

.report-modal-btn-submit:disabled {
  background: #CDCCCD;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 480px) {
  .report-modal {
    width: 100%;
    max-height: 90vh;
    border-radius: 20px 20px 0 0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .report-modal-overlay {
    align-items: flex-end;
    padding: 0;
  }

  .report-modal-title {
    font-size: 22px;
  }

  .report-modal-actions {
    flex-direction: column-reverse;
  }

  .report-modal-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal/ReportMessageModal.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;EACV;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/**\n * ReportMessageModal Styles\n * Modal for reporting messages with severity and reason\n */\n\n/* Overlay */\n.report-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n/* Modal Container */\n.report-modal {\n  background: #FFFFFF;\n  border-radius: 20px;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);\n  width: 450px;\n  max-width: 90vw;\n  display: flex;\n  flex-direction: column;\n  font-family: 'Open Sans', sans-serif;\n  overflow: hidden;\n}\n\n/* Header */\n.report-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 24px 16px 24px;\n  position: relative;\n}\n\n.report-modal-title {\n  margin: 0;\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 100%;\n  letter-spacing: 0;\n  color: #2E2E2E;\n  text-align: center;\n}\n\n.report-modal-close {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  background: #4A4A4A;\n  border: none;\n  font-size: 20px;\n  color: #FFFFFF;\n  cursor: pointer;\n  padding: 0;\n  border-radius: 50%;\n  transition: background 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  line-height: 1;\n}\n\n.report-modal-close:hover {\n  background: #333333;\n}\n\n/* Body */\n.report-modal-body {\n  padding: 0 24px 16px 24px;\n}\n\n/* Form Fields */\n.report-modal-field {\n  margin-bottom: 16px;\n}\n\n.report-modal-label {\n  display: block;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #4A4A4A;\n  margin-bottom: 8px;\n}\n\n/* Severity Dropdown */\n.report-modal-select {\n  width: 100%;\n  height: 44px;\n  padding: 10px 16px;\n  border: 2px solid #CDCCCD;\n  border-radius: 8px;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  color: #000000;\n  background: #FFFFFF;\n  cursor: pointer;\n  appearance: auto;\n}\n\n.report-modal-select:focus {\n  outline: none;\n  border-color: #DE4858;\n}\n\n/* Reason Textarea */\n.report-modal-textarea {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #CDCCCD;\n  border-radius: 8px;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  color: #000000;\n  background: #FFFFFF;\n  resize: vertical;\n  min-height: 100px;\n  box-sizing: border-box;\n}\n\n.report-modal-textarea:focus {\n  outline: none;\n  border-color: #DE4858;\n}\n\n.report-modal-textarea::placeholder {\n  color: #9B9B9B;\n}\n\n/* Encryption Warning */\n.report-modal-encryption-warning {\n  color: #E67E22;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  margin: 8px 0 0 0;\n  padding: 10px 12px;\n  background-color: rgba(230, 126, 34, 0.1);\n  border-radius: 8px;\n  border-left: 3px solid #E67E22;\n}\n\n/* Action Buttons */\n.report-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  padding: 20px 24px 24px 24px;\n  border-top: 1px solid #E5E5E5;\n}\n\n.report-modal-btn {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 100%;\n  letter-spacing: 0;\n  height: 45px;\n  padding: 10px 24px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  min-width: 100px;\n}\n\n.report-modal-btn-cancel {\n  background: #D8D8D8;\n  color: #6A6A6A;\n  border: none;\n}\n\n.report-modal-btn-cancel:hover:not(:disabled) {\n  background-color: #CDCCCD;\n}\n\n.report-modal-btn-cancel:disabled {\n  background: #E8E8E8;\n  color: #AAAAAA;\n  cursor: not-allowed;\n}\n\n.report-modal-btn-submit {\n  background: #DE4858;\n  color: #FFFFFF;\n  border: none;\n}\n\n.report-modal-btn-submit:hover:not(:disabled) {\n  background: #C83E4E;\n}\n\n.report-modal-btn-submit:disabled {\n  background: #CDCCCD;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 480px) {\n  .report-modal {\n    width: 100%;\n    max-height: 90vh;\n    border-radius: 20px 20px 0 0;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n  }\n\n  .report-modal-overlay {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .report-modal-title {\n    font-size: 22px;\n  }\n\n  .report-modal-actions {\n    flex-direction: column-reverse;\n  }\n\n  .report-modal-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
